import React, { useEffect, useMemo, useState } from "react";
import { useWallet } from "./hooks/content";
import {
  checkUsername,
  createNFTProfile,
  mintUsername,
  setUserPrimaryName,
} from "./hooks/helper";
import {
  useWriteContract,
  useReadContracts,
  useAccount,
  useReadContract,
  useSwitchChain,
} from "wagmi";
import { towneSquareContract } from "../../constants/constants";
import { parseEther } from "viem";
import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { eth_sendRawTransaction } from "thirdweb";

const TownesquareNFT = ({ onConnect }: { onConnect?: () => void }) => {
  const queryClient = useQueryClient();
  const [username, setUsername] = useState<string>("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { pubAddress, setPubAddress, connectedWallet } = useWallet();
  const { chains, switchChain, switchChainAsync } = useSwitchChain();
  const account = useAccount();
  const [error, setError] = useState("");
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  const { writeContract, writeContractAsync } = useWriteContract();

  const validateUsername = async (value: string) => {
    if (value.trim() === "") {
      setError("");
    } else if (value.length < 5) {
      setError("Username must be longer than 4 characters.");
    } else if (!/^[a-zA-Z0-9_]+$/.test(value)) {
      setError("Use only letters, numbers, or underscore.");
    } else if (value.length > 15) {
      setError("Username can be max. 15 characters long.");
    } else if (value.length > 6) {
      try {
        const res = await checkUsername(value);
        if (res.data.isExist) {
          setError("Username is already taken");
        }
      } catch (error: any) {
        setError(error.message);
      }
    } else {
      setError("");
    }
  };

  const {
    data: userPrimaryNFT,
    isSuccess,
  }: { data: [string, string] | undefined; isSuccess: boolean } =
    useReadContract({
      ...towneSquareContract,
      functionName: "userPrimaryNFT",
      args: [account.address],
      query: {
        staleTime: 86400000,
        refetchOnWindowFocus: false,
      },
    });

  const handleUsernameChange = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setError("");
    const value = e.target.value;
    setUsername(value);
    await validateUsername(value);
  };

  const result = useReadContracts({
    contracts: [
      {
        ...towneSquareContract,
        functionName: "totalSupply",
      },
      {
        ...towneSquareContract,
        functionName: "mintStatus",
        args: [pubAddress],
      },
    ],
    query: {
      staleTime: 86400000,
      refetchOnWindowFocus: false,
      initialData: [
        { result: 10000, status: "success" },
        { result: false, status: "success" },
      ],
    },
  });

  const totalSupply = useReadContract({
    ...towneSquareContract,
    functionName: "totalSupply",
    query: {
      initialData: 100,
    },
  });

  const mintStatus = useReadContract({
    ...towneSquareContract,
    functionName: "mintStatus",
    query: {
      initialData: false,
    },
  });

  const totalMinted = useReadContract({
    ...towneSquareContract,
    functionName: "totalMinted",
    query: {
      initialData: 0,
    },
  });

  const handleMintUsername = async () => {
    setIsLoading(true);
    try {
      const tokenUrl = await createNFTProfile(username);
      console.log(account.connector?.name, "connector");
      if (account.connector?.name.toLocaleLowerCase() !== "backpack") {
        await switchChainAsync(
          { chainId: Number(10143) },
          {
            onSuccess: () => {
              // alert(`switch chain ${chainId} `);
            },
            onError(error, variables, context) {
              // alert(`Error ${error} ${chainId} `);
              setIsLoading(false);
            },
          }
        );
      }

      writeContractAsync(
        {
          ...towneSquareContract,
          functionName: "mintUsername",
          args: [username, tokenUrl],
          value: parseEther("1"),
        },
        {
          onSuccess: async () => {
            setIsLoading(false);
            setIsModalOpen(true);
            //await mintUsername(username);
          },
          onError(error, variables, context) {
            setIsLoading(false);
            console.log(error.message);
          },
        }
      );
    } catch (error) {
      setIsLoading(false);
    }
  };

  // useEffect(() => {
  //   localStorage.setItem("username", username);
  // }, [username]);

  return (
    <div className="flex flex-col items-center justify-start min-h-screen p-4 text-white">
      <div className="md:hidden w-full">
        <span className="block text-[23px] font-semibold mb-8 mt-4 text-start">
          TowneSquare NFTs
        </span>
      </div>
      <div className="grid w-full max-w-5xl grid-cols-1 gap-8 md:p-6  md:grid-cols-2">
        {/* Image Section */}
        {/* Show this WHen live */}

        <div className="flex flex-col">
          <div className="relative md:w-[413px] h-[413px] w-full ">
            {" "}
            <img
              src="/assets/main_v4/nftholder.svg"
              alt="NFT Image"
              className="object-cover w-full h-full rounded-xl"
            />
            <span
              className="absolute flex justify-center items-center w-[271px] gap-[2px] h-[46px] py-4 leading-[26px] rounded-[16px]
    text-white font-outfit text-[20px] font-semibold text-center pointer-events-none"
              style={{
                background: "#32274B",
                borderBottom: "1.38px solid",
                top: "176px",
                left: "50%",
                transform: "translateX(-50%)",
                position: "absolute",
              }}
            >
              <span className="text-[25px] font-bold">@</span>
              <span className="-mb-1">
                {/* { `${userPrimaryNFT?.length ? userPrimaryNFT[1] ? username :  "Your username"}` */}
                {`${
                  userPrimaryNFT && userPrimaryNFT[1]
                    ? userPrimaryNFT[1]
                    : username
                    ? username
                    : "Your username"
                }`}
              </span>
            </span>
          </div>
        </div>

        {/* Coming Soon State */}
        {/* <img src="/assets/main_v4/nft_coming_soon.svg" /> */}

        {/* Details Section */}
        <div className="flex flex-col justify-between bg-[#121212] md:-ml-8 md:px-6 py-8 px-4 border border-[#B882FF] rounded-2xl text-white md:w-[531px] w-full mx-auto">
          <div className="text-center">
            <h1 className="text-[29px] leading-[36.54px] font-bold">
              Mint TowneSquare’s
            </h1>
            <h2 className="mt-1 text-[29px] leading-[36.54px] font-bold text-purple-400">
              Nad Profile NFT - OG edition
            </h2>
            <p className="flex items-center justify-center gap-1 mt-2 text-base font-semibold text-[#CCCCCC]">
              Exclusive to{" "}
              <img
                src="/assets/main_v4/monadtes.svg"
                alt="Monad Logo"
                className="w-auto h-auto"
              />
            </p>
            <div className="my-[33px]">
              <p className=" text-[15px] leading-[20.5px] text-start">
                Be among the first to mint{" "}
                <span className="font-bold">
                  TowneSquare’s Profile NFT, the OG edition!
                </span>{" "}
                Create your Monad exclusive on-chain profile & get extra rank
                bonus on all transactions on Monad DeFi protocols done through
                TowneSquare.
              </p>
              <p className="mt-4 font-bold">
                OG edition supply - {Number(totalSupply.data).toLocaleString()}{" "}
                NFTs
              </p>
            </div>
          </div>
          <div className=" hidden md:flex justify-center gap-[38px] mb-[40px]">
            <div className="flex flex-col gap-[38px]">
              <div className="flex items-center gap-2">
                <img
                  src="/assets/main_v4/extra.svg"
                  alt="Extra Rank Bonus"
                  className="w-[34px] h-[34px]"
                />
                <span className="text-[16px] w-[150px] leading-[19px] font-semibold">
                  Extra rank bonus on all transactions
                </span>
              </div>
              <div className="flex items-center gap-2">
                <img
                  src="/assets/main_v4/Og.svg"
                  alt="First Adopter Edition"
                  className="w-[34px] h-[34px]"
                />
                <span className=" text-[16px] w-[142px]  leading-[19px] font-semibold">
                  First adopter edition
                </span>
              </div>
            </div>
            <div className="flex flex-col gap-[38px]">
              <div className="flex items-center gap-2">
                <img
                  src="/assets/main_v4/per.svg"
                  alt="Personalized Username"
                  className="w-[34px] h-[34px]"
                />
                <span className="text-[16px w-[138px] leading-[19px] font-semibold">
                  Personalized username
                </span>
              </div>

              <div className="flex items-center gap-2">
                <img
                  src="/assets/main_v4/Tsbadge.svg"
                  alt="Purple Badge"
                  className="w-[34px] h-[34px]"
                />
                <span className="text-[16px] w-[138px]  leading-[19px] font-semibold">
                  TowneSquare Purple Badge
                </span>
              </div>
            </div>
          </div>
          {/* mobile version view */}
          <div className="md:hidden flex  gap-[38px] ml-8 mb-[40px]">
            <div className="flex flex-col gap-[38px]">
              <div className="flex items-center gap-2">
                <img
                  src="/assets/main_v4/extra.svg"
                  alt="Extra Rank Bonus"
                  className="w-[34px] h-[34px]"
                />
                <span className="text-[16px] w-[150px] leading-[19px] font-semibold">
                  Extra rank bonus on all transactions
                </span>
              </div>
              <div className="flex items-center gap-2">
                <img
                  src="/assets/main_v4/Og.svg"
                  alt="First Adopter Edition"
                  className="w-[34px] h-[34px]"
                />
                <span className=" text-[16px] w-[142px]  leading-[19px] font-semibold">
                  First adopter edition
                </span>
              </div>
              <div className="flex items-center gap-2">
                <img
                  src="/assets/main_v4/per.svg"
                  alt="Personalized Username"
                  className="w-[34px] h-[34px]"
                />
                <span className="text-[16px w-[138px] leading-[19px] font-semibold">
                  Personalized username
                </span>
              </div>

              <div className="flex items-center gap-2">
                <img
                  src="/assets/main_v4/Tsbadge.svg"
                  alt="Purple Badge"
                  className="w-[34px] h-[34px]"
                />
                <span className="text-[16px] w-[138px]  leading-[19px] font-semibold">
                  TowneSquare Purple Badge
                </span>
              </div>
            </div>
          </div>

          <div className="w-full h-[1px] border border-[#666666] mb-10"></div>

          {/* <div className="text-center text-[14px] mb-[10px]">
            <p>
              OG Profile NFTs minted:{" "}
              <span className="font-bold text-[#B882FF]">
                {`${0}/`}
                <span className="text-[#B882FF]">{(10000).toLocaleString()}</span>
              </span>
            </p>
          </div>

          <div className="w-[337px] h-2 mx-auto bg-[#666666] border border-[#666666] rounded-[12px]">
            <div
              className="h-full duration-500 ease-in-out rounded bg-[#9264F8] transition-width"
              style={{
                width: `${0}%`,
              }}
            ></div>
          </div> */}
          {/* show this when live */}
          <div className="text-center text-[14px] mb-[10px]">
            <p>
              OG Profile NFTs minted:{" "}
              <span className="font-bold text-[#FFF]">{`${Number(
                totalMinted.data
              ).toLocaleString()}/`}</span>{" "}
              <span className="font-bold text-[#B882FF]">{`${Number(
                totalSupply.data
              ).toLocaleString()}`}</span>
            </p>
          </div>

          <div className="w-[337px] h-2 mx-auto bg-[#666666] border border-[#666666] rounded-[12px]">
            <div
              className="h-full duration-500 ease-in-out rounded bg-[#9264F8] transition-width"
              style={{
                width: `${
                  (Number(totalMinted.data) / Number(totalSupply.data)) * 100
                }%`,
              }}
            ></div>
          </div>

          <div className="flex items-center justify-center gap-2 py-[30px] px-[30px]">
            <p> Mint Price: </p>

            <p className="font-bold">0.1</p>
            <img
              src="/assets/main_v4/montoken.svg"
              alt="MON Token"
              className="w-5 h-5"
            />
            <p className="font-bold -ml-[3px]">MON</p>
          </div>

          <div className="flex flex-col items-center justify-center mb-[32px]">
            <div className="flex flex-row justify-center mb-4">
              {" "}
              <span className="text-center text-[15px]  text-white  font-medium mr-2  ">
                Choose your TowneSquare username
              </span>{" "}
              {/* <img src="/assets/main_v4/Info2.svg" /> */}
            </div>

            <input
              type="text"
              maxLength={16}
              placeholder="@ Insert username"
              className={`w-[250px] h-[40px] px-4 border outline-none rounded-[40px] bg-[#000000] text-white font-semibold ${
                error ? "border-[#FF4471]" : "border-[#AAAA]"
              }`}
              value={username}
              onChange={handleUsernameChange}
            />
            {error && (
              <p className="text-[#FF4471] text-[15px] font-semibold mt-1">
                {error}
              </p>
            )}

            <div className="flex flex-row justify-center mt-[10px] w-[240px]">
              <img src="/assets/main_v4/Info.svg" />
              <p className="text-[13px] text-white ml-2 text-start">
                It can only contain letters, numbers, and underscores.
              </p>{" "}
            </div>
          </div>
          <div className="flex items-center justify-center">
            {account.isConnected ? (
              <button
                className={`min-w-[250px] h-10 px-6 flex justify-center items-center  disabled:opacity-50 disabled:cursor-not-allowed bg-[#9264F8] hover:bg-[#9F71FF]  font-semibold rounded-[48px]`}
                onClick={() => handleMintUsername()}
                disabled={
                  !!error ||
                  username.trim() === "" ||
                  Boolean(mintStatus.data) == true ||
                  isLoading
                }
              >
                {mintStatus.data && mintStatus.data == true ? (
                  "Max 1 NFT per wallet"
                ) : Number(totalSupply.data) == Number(totalMinted.data) ? (
                  "Mint finished"
                ) : isLoading ? (
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill={"#FFF"}
                    xmlns="http://www.w3.org/2000/svg"
                    className="animate-spin"
                  >
                    <path d="M10.75 1.5V4.5C10.75 4.69891 10.671 4.88968 10.5303 5.03033C10.3897 5.17098 10.1989 5.25 10 5.25C9.80109 5.25 9.61032 5.17098 9.46967 5.03033C9.32902 4.88968 9.25 4.69891 9.25 4.5V1.5C9.25 1.30109 9.32902 1.11032 9.46967 0.96967C9.61032 0.829018 9.80109 0.75 10 0.75C10.1989 0.75 10.3897 0.829018 10.5303 0.96967C10.671 1.11032 10.75 1.30109 10.75 1.5ZM19 9.75H16C15.8011 9.75 15.6103 9.82902 15.4697 9.96967C15.329 10.1103 15.25 10.3011 15.25 10.5C15.25 10.6989 15.329 10.8897 15.4697 11.0303C15.6103 11.171 15.8011 11.25 16 11.25H19C19.1989 11.25 19.3897 11.171 19.5303 11.0303C19.671 10.8897 19.75 10.6989 19.75 10.5C19.75 10.3011 19.671 10.1103 19.5303 9.96967C19.3897 9.82902 19.1989 9.75 19 9.75ZM14.7728 14.2125C14.631 14.0778 14.4422 14.0038 14.2466 14.0063C14.0511 14.0088 13.8642 14.0876 13.7259 14.2259C13.5876 14.3642 13.5088 14.5511 13.5063 14.7466C13.5038 14.9422 13.5778 15.131 13.7125 15.2728L15.8331 17.3944C15.9739 17.5351 16.1647 17.6142 16.3638 17.6142C16.5628 17.6142 16.7536 17.5351 16.8944 17.3944C17.0351 17.2536 17.1142 17.0628 17.1142 16.8638C17.1142 16.6647 17.0351 16.4739 16.8944 16.3331L14.7728 14.2125ZM10 15.75C9.80109 15.75 9.61032 15.829 9.46967 15.9697C9.32902 16.1103 9.25 16.3011 9.25 16.5V19.5C9.25 19.6989 9.32902 19.8897 9.46967 20.0303C9.61032 20.171 9.80109 20.25 10 20.25C10.1989 20.25 10.3897 20.171 10.5303 20.0303C10.671 19.8897 10.75 19.6989 10.75 19.5V16.5C10.75 16.3011 10.671 16.1103 10.5303 15.9697C10.3897 15.829 10.1989 15.75 10 15.75ZM5.22719 14.2125L3.10562 16.3331C2.96489 16.4739 2.88583 16.6647 2.88583 16.8638C2.88583 17.0628 2.96489 17.2536 3.10562 17.3944C3.24636 17.5351 3.43723 17.6142 3.63625 17.6142C3.83527 17.6142 4.02614 17.5351 4.16687 17.3944L6.2875 15.2728C6.42221 15.131 6.49621 14.9422 6.4937 14.7466C6.4912 14.5511 6.4124 14.3642 6.2741 14.2259C6.1358 14.0876 5.94894 14.0088 5.75337 14.0063C5.5578 14.0038 5.36898 14.0778 5.22719 14.2125ZM4.75 10.5C4.75 10.3011 4.67098 10.1103 4.53033 9.96967C4.38968 9.82902 4.19891 9.75 4 9.75H1C0.801088 9.75 0.610322 9.82902 0.46967 9.96967C0.329018 10.1103 0.25 10.3011 0.25 10.5C0.25 10.6989 0.329018 10.8897 0.46967 11.0303C0.610322 11.171 0.801088 11.25 1 11.25H4C4.19891 11.25 4.38968 11.171 4.53033 11.0303C4.67098 10.8897 4.75 10.6989 4.75 10.5ZM4.16687 3.60562C4.02614 3.46489 3.83527 3.38583 3.63625 3.38583C3.43723 3.38583 3.24636 3.46489 3.10562 3.60562C2.96489 3.74636 2.88583 3.93723 2.88583 4.13625C2.88583 4.33527 2.96489 4.52614 3.10562 4.66687L5.22719 6.7875C5.36898 6.92221 5.5578 6.99621 5.75337 6.9937C5.94894 6.9912 6.1358 6.9124 6.2741 6.7741C6.4124 6.6358 6.4912 6.44894 6.4937 6.25337C6.49621 6.0578 6.42221 5.86898 6.2875 5.72719L4.16687 3.60562Z" />
                  </svg>
                ) : (
                  "Mint Profile NFT"
                )}
              </button>
            ) : (
              <button
                className="w-[250px] h-10 px-6 font-semibold rounded-[48px] bg-[#9264F8] hover:bg-[#9F71FF] text-white flex items-center justify-center cursor-pointer"
                onClick={onConnect}
              >
                Connect Wallet
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Community Section */}
      <div className="flex flex-row justify-end w-full max-w-5xl md:pl-4 px-4 md:px-0 md:ml-10">
        <div className=" md:w-[530px] w-full py-10 md:px-4 px-0">
          <p className="text-white font-bold text-[20px]">
            <span className="text-purple-400 text-[20px] font-bold">Monad</span>{" "}
            has a proud community of OGs. <br />
            <span className="font-bold text-[20px]">Are you one of them?</span>
          </p>
          <p className="font-outfit text-[15px] font-normal leading-[20.55px] text-left text-[#CCCCCC] pr-4">
            Projects farm users and people are tired. Monad is ushering in a new
            way of community building. Community members, big and small, can all
            be OGs regardless of their wallet size.
          </p>

          <p className="text-white font-bold text-[20px] pt-8">
            We on{" "}
            <span className="text-purple-400 font-bold text-[20px]">Monad</span>{" "}
            are redefining “OG” in crypto.
          </p>
          <p className="font-outfit text-[15px] font-normal leading-[20.55px] text-left text-[#CCCCCC]  ">
            We don’t want our project to be another farming project in crypto
            built for VCs.
          </p>
          <p className="font-outfit text-[15px] font-normal leading-[20.55px] text-left text-[#CCCCCC] py-4">
            We want to power users to explore Monad and DeFi to make it to the
            next step for yourself, to get to where you want to go, to see a
            vision together, and to thrive.
          </p>

          <p className="font-outfit text-[15px] font-normal leading-[20.55px] text-left text-[#CCCCCC] py-4">
            Every line of this text is a testament from our community-driven
            approach. DM us if you are willing on X{" "}
            <a
              href="https://x.com/TowneSquarexyz"
              className="text-blue-400 underline"
            >
              @townesquarexyz
            </a>{" "}
            or on{" "}
            <a
              href="https://discord.com/invite/yMRmqFzrDW"
              className="text-blue-400 underline"
            >
              Discord
            </a>
            , we’ve got "TowneSquare purple" for a surprise!
          </p>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-80">
          <div className="bg-[#121212] px-8 py-8 rounded-lg border border-[#404040] relative max-w-[520px] w-full mx-4">
            {/* Close Button - Top Right */}
            <button
              className="absolute pl-12 mb-6 transition-opacity top-4 right-4 hover:opacity-80"
              onClick={() => setIsModalOpen(false)}
            >
              <img
                src="/assets/main_v4/close.svg"
                className="w-6 h-6"
                alt="Close"
              />
            </button>

            <div className="flex flex-col items-center space-y-6">
              <div className="mt-2 text-center">
                <h2 className="text-xl font-semibold">
                  Welcome to the <br />
                  <span className="text-[#B882FF] font-bold">
                    OG Nad community!
                  </span>
                </h2>
              </div>

              {/* NFT Preview */}
              <div className="relative w-full max-w-[285px]">
                <img
                  src="/assets/main_v4/nftholder.svg"
                  alt="NFT Image"
                  className="w-[285] h-[285px] aspect-square rounded-xl"
                />
                <span
                  className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 
            w-[187px] py-2 rounded-lg border-b-[1.4px] border-transparent
            bg-[#32274B] text-white font-semibold text-center text-[16px]
            bg-gradient-to-b from-[#C4B3E7] to-[#DACCF5] bg-clip-text"
                  style={{
                    background: "#32274B",
                    borderBottom: "1.38px solid",
                    // borderImage: "linear-gradient(90deg, #C4B3E7, #DACCF5) 1",
                    transform: "translate(-50%, -50%)",
                  }}
                >
                  {username ? `@${username}` : "@Your username"}
                </span>
              </div>

              <p className="text-lg font-semibold text-center">
                Nad Profile NFT - OG edition #1
              </p>

              <button
                className="bg-[#9264f8] hover:bg-[#8154e0] text-white font-bold py-3 px-8 rounded-[32px] transition-colors"
                onClick={() => {
                  setUsername("");
                  setIsModalOpen(false);
                }}
              >
                Great
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TownesquareNFT;
